import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";


//dropdown with search and manual typing override.
//need to provide label, options, value, valueChangeHandler.
//change to value will return the new value to the parent component through valueChangeHandler

export default function TypableDropdownInput({ label, options, value, valueChangeHandler, forcedValue, renderInputParams, sx  }) {

  //autocomplete component has two states: inputValue and selectedValue.
  //inputValue is the value of the text input field, selectedValue is the value of the selected option from the dropdown.
  const [inputValue, setInputValue] = useState(value || '');
  const [selectedValue, setSelectedValue] = useState(value || '');

  //set both of the states, then wait for useEffect to call the valueChangeHandler.
  const handleChange = (newValue) => {
    if (newValue === null) {
      setInputValue('');
      setSelectedValue('');
      return;
    }
    setInputValue(newValue); 
    setSelectedValue(newValue);
  }

  useEffect(() => {
    ///once both states are synced, call valueChangeHandler if it is different from previous value (to prevent unneeded calls)
    if (selectedValue === inputValue && selectedValue !== value) {
      valueChangeHandler(inputValue);
    }
  }, [selectedValue, inputValue]);


  //if the 'forcedValue' prop changes at any time, update the inputValue and selectedValue states to match it.
  //this is useful for when the parent component wants to force a value on the input field. 
  useEffect(() => {
    if (forcedValue) {
      if (forcedValue !== selectedValue || forcedValue !== inputValue) {
        setInputValue(forcedValue);
        setSelectedValue(forcedValue);
      }
    }
  }, [forcedValue]);

  return (
    <Autocomplete
      inputValue={inputValue}// inputValue is the value of the input field
      value={selectedValue}/// value is the value of the selected option
      freeSolo
      //onChange event is triggered when the user selects an option from the dropdown
      onChange={(event, newVal) => {
        handleChange(newVal);
      }}
      //onInputChange event is triggered when the user types in the input field
      onInputChange={(event, newVal) => {
        handleChange(newVal);
      }}

      options={options}
      sx={{ width: "100%", ...sx }}
      size="small"
      renderInput={(params) => <TextField {...params} {...renderInputParams} label={label}/>}
    />
  )
}